import OnEvent from "../decorators/on-event"
import ListService from "../services/list-service"
import Routing from "./routing"
import Singleton from "../decorators/singleton"
import ErrorHandlers from "../listing/error-handlers"

export default class CreateNewList {

    @Singleton
    private routing: Routing

    @Singleton
    private listService: ListService

    @Singleton
    private errorHandler: ErrorHandlers

    @OnEvent({
        selector: '[create-new-list]'
    })
    private createNewList(): void {
        ListService.createNewList()
            .then(id => this.routing.routeToId(id))
            .catch(() => this.errorHandler.createListErrorState())
    }

    @OnEvent({
        selector: '[expired-create]'
    })
    private expiredCreate(): void {
        this.listService.leaveList()
        this.createNewList()
    }
}